import { env } from 'core/utils';
import type { FroalaOptions } from '@iqx-web/libs/froala-editor';

export const defaultConfig: Partial<FroalaOptions> = {
  key: env.FROALA_EDITOR_KEY,
  attribution: false,
  charCounterCount: false,
  lineBreakerTags: ['foo'], // ['table', 'hr', 'form']
  linkAlwaysBlank: true,
  linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
  linkInsertButtons: ['linkBack'], // 'linkList'
  paragraphDefaultSelection: 'Normal',
  paragraphFormat: { N: 'Normal', H1: 'Title', BLOCKQUOTE: 'Quote', PRE: 'Code' },
  paragraphFormatSelection: true,
  placeholderText: '',
  quickInsertEnabled: false,
  htmlAllowedTags: ['.*'],
  pluginsEnabled: ['align', 'colors', 'link', 'paragraphFormat', 'lists', 'fullscreen', 'table'],
  toolbarButtons: {
    moreParagraph: {
      buttons: ['paragraphFormat', 'align', 'formatOL', 'formatUL'],
      buttonsVisible: 4,
    },
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'textColor',
        'backgroundColor',
        'clearFormatting',
      ],
      buttonsVisible: 0,
    },
    moreRich: {
      buttons: ['insertLink', 'insertTable'],
      buttonsVisible: 3,
    },
    moreMisc: {
      buttons: ['fullscreen', 'insert'],
      align: 'right',
      buttonsVisible: 4,
    },
  },
};
